import styled from "@emotion/styled";

export const EnterLicenseModalContainer = styled.div`
    width: 100%;
    gap: 1rem;
    color: #000000;
    position: relative;
    border-radius: 0.75rem;

    @media (min-width: 768px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;

export const EnterLicenseModalContentContainer = styled.div`
    overflow-y: auto;
    max-height: 35em;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 15px;
`;

export const EnterLicenseModalTitle = styled.h1`
    font-size: 22px;
    margin-top: 5px;
    border-bottom: 2px solid rgb(22, 59, 93);
    padding: 5px;
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 15px;
    width: 100%;
    flex-direction: column;
    margin: 0px auto;
`;

export const EnterLicenseButton = styled.button`
    background-color: rgb(22, 59, 93);
    border-radius: 0.8em;
    font-size: 0.938rem;
    font-weight: 500;
    padding:0.6em 1.3em;
    color: white;
    border: none;
    margin: 0px auto;
`;

export const ModalText = styled.div`
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
`

export const BuyNowButton = styled.button`
    border-radius: 0.8em;
    font-size: 0.938rem;
    font-weight: 500;
    padding:0.6em 1.3em;
    background-color: rgb(202, 215, 228);
    color: black;
    border: none;
`;
export const Input = styled.input`
  border: 1px solid #cad7e4;
  border-radius: 4px;
  padding: 0.6em 1.3em;
  font-size: 14px;
  width: 100%;
  text-align: center;
  &:focus {
    outline: none;
  }
  margin: 0 auto; // Center the input if desired
`;